import React from 'react';
import ReactDOM from 'react-dom';
import template from "lodash/template";
import { getPatientGroup } from "general/utils";
import { WorkplaceAlert } from "general/components/alert/WorkplaceAlert";

import "general/pages/profile/common";

$(document).ready(function () {
  const workplaceData = document.querySelector("#workplace-data").dataset;

  $("#booking-calendar").booking({
    id: "workplace-calendar",
    workplaceId: workplaceData.workplaceId,
    templates: {
      form: template($("#appointment-form-template").html())
    }
  });

  const alertEl = document.querySelector("#react-profile-alert");
    const pgName = getPatientGroup();
    if (alertEl) {
      ReactDOM.render(
        <React.StrictMode>
          <WorkplaceAlert
            pgName={pgName}
            workplaceId={workplaceData.workplaceId}
          />
        </React.StrictMode>,
        alertEl
      )
    }

});
